/**
 * Super Admin company feature flags from restaurant / settings payloads.
 * Missing values default to allowed (matches API entity defaults).
 */

function readFlag(source, camelKey, pascalKey) {
  if (!source || typeof source !== "object") return undefined;
  if (Object.prototype.hasOwnProperty.call(source, camelKey)) {
    return source[camelKey];
  }
  if (Object.prototype.hasOwnProperty.call(source, pascalKey)) {
    return source[pascalKey];
  }
  return undefined;
}

function coerceAllowed(value) {
  if (value === false || value === 0 || value === "0" || value === "false") {
    return false;
  }
  // true, "true", 1, null, undefined → allowed
  return true;
}

/**
 * @param {object|null|undefined} restaurantData
 * @param {object|null|undefined} [companySettings]
 */
export function isOnlineOrderingAllowed(restaurantData, companySettings = null) {
  const fromRestaurant = readFlag(
    restaurantData,
    "isOnlineOrderingAllowed",
    "IsOnlineOrderingAllowed"
  );
  if (fromRestaurant !== undefined) return coerceAllowed(fromRestaurant);

  const fromSettings = readFlag(
    companySettings,
    "isOnlineOrderingAllowed",
    "IsOnlineOrderingAllowed"
  );
  if (fromSettings !== undefined) return coerceAllowed(fromSettings);

  return true;
}

/**
 * @param {object|null|undefined} restaurantData
 * @param {object|null|undefined} [companySettings]
 */
export function isReservationAllowed(restaurantData, companySettings = null) {
  const fromRestaurant = readFlag(
    restaurantData,
    "isReservationAllowed",
    "IsReservationAllowed"
  );
  if (fromRestaurant !== undefined) return coerceAllowed(fromRestaurant);

  const fromSettings = readFlag(
    companySettings,
    "isReservationAllowed",
    "IsReservationAllowed"
  );
  if (fromSettings !== undefined) return coerceAllowed(fromSettings);

  return true;
}
